/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Banner_TitleInputs */

const da_consent_banner_title = /** @type {(inputs: Consent_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Må vi bruge cookies til statistik?`)
};

/** @type {(inputs: Consent_Banner_TitleInputs) => LocalizedString} */
const en_consent_banner_title = da_consent_banner_title;

/**

* @param {Consent_Banner_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_banner_title = /** @type {((inputs?: Consent_Banner_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Banner_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_banner_title(inputs)
	return /** @type {LocalizedString} */ ("Må vi bruge cookies til statistik?")
});